<template>
  <div>
    <van-cell-group class="packageStyle">
      <van-cell title="套餐名称：" :value="details.Name" v-if="FullName" />
      <van-cell title="租 金：" :value="'￥'+details.Price" />
      <van-cell title="押 金：" :value="'￥'+details.Deposit" />
      <van-cell title="有效时长：" :value="details.ValidityEndTimeStr" />
      <van-cell title="备 注：" :value="details.Text" />
      <van-cell title="总 计：" :value="'￥'+(details.Price+details.Deposit)" />
    </van-cell-group>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  props: {
    details: {
      type: Object,
      default: () => {
        return {
          Name: '',
          Price: '',
          Deposit: '',
          ValidityEndTimeStr: '',
          Text: ''
        }
      }
    },
    FullName: {
      type: Boolean,
      default: () => {
        return true
      }
    }
  },
  components: {},
  methods: {},
  mounted () {}
}
</script>

<style lang="less" scoped>
</style>
